module.exports = __webpack_public_path__ + "img/webservice.33799e3b.svg";